/**
 * This is called when the state directive is used.
 *
 * @param {object} ele
 * @param {*} data
 * @param {object} parent
 * @returns {void}
 */
export const state = (ele, data, parent) =>
{

};